import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Cadence } from '@anduin/api';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-collections-auto-approve',
  templateUrl: './collections-auto-approve.component.html',
  styleUrls: ['./collections-auto-approve.component.scss'],
  standalone: false,
})
export class CollectionsAutoApproveComponent implements OnInit, OnDestroy {
  _unsubscribe: Subject<void> = new Subject<void>();

  @Input() set autoApprove(newValue: boolean) {
    if (newValue !== null && newValue !== undefined) {
      this.autoApproveControl.setValue(newValue, { emitEvent: false });
    }
  }

  private _disabled = false;

  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.autoApproveControl.disable();
    } else {
      this.autoApproveControl.enable();
    }
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Output() autoApproveChange = new EventEmitter();

  autoApproveControl: UntypedFormControl = new UntypedFormControl(false);

  ngOnInit() {
    this.autoApproveControl.valueChanges
      .pipe(
        tap((value) => this.autoApproveChange.emit(!!value)),
        takeUntil(this._unsubscribe),
      )
      .subscribe();
  }

  reset(autoApprove: boolean): void {
    this.autoApprove = autoApprove;
  }

  ngOnDestroy() {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
